import { effects as transactionsEffects } from './transactions';
import { effects as sessionsEffects } from './sessions';
import { effects as virtualTerminalEffects } from './virtualTerminal';

const effects = {
    ...transactionsEffects,
    ...sessionsEffects,
    ...virtualTerminalEffects,
};

export default effects;
